<form [formGroup]="socialMediaForm" (ngSubmit)="saveSocialMedia(inProgress)">
    <div class=" modal-header">
      <h5 class="modal-title d-flex align-items-center">
        <i class='ri-question-answer-line me-1 font-20 text-primary'></i>
        {{socialMediaForm.value.id?'Update':'Add'}} Social Media
      </h5>
      <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
        (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-md-6">
          <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
          <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-rename' ></i></span>
            <input type="text" class="form-control ps-1" id="name" placeholder="Enter a valid name"
              [ngClass]="{'is-invalid': submitted && c.controls.name.errors}" formControlName="name" ngbAutofocus
              autocomplete="off" />
            <div class="invalid-feedback" *ngIf="submitted && c.controls.name.errors">
              <span *ngIf="c.controls.name.errors.required">Please provide a valid name.</span>
              <span *ngIf="c.controls.name.errors.pattern">Only letters are allowed.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label for="website" class="form-label">Website<b class="text-secondary">*</b></label>
          <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-globe'></i></span>
            <input type="text" class="form-control ps-1" id="website" placeholder="Enter a valid website"
              [ngClass]="{'is-invalid': submitted && c.controls.website.errors}" formControlName="website"
              autocomplete="off" />
            <div class="invalid-feedback" *ngIf="submitted && c.controls.website.errors">
              <span *ngIf="c.controls.website.errors.required">Please provide a valid website.</span>
              <span *ngIf="c.controls.website.errors.pattern">Please provide a valid website.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label for="Logo" class="form-label">Logo</label>
          <div class="input-group" formControlName="logo">
            <input type="file" class="custom-file-input form-control" id="upload" (change)="getAndSetLogo($event)"
              accept=".jpg,.jpeg,.png"> 
          </div>
        </div>
          <div class="col-md-6">
            <label for="colour" class="form-label">Color</label>
            <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-palette"></i></span>
              <input type="text" class="form-control ps-1" id="colour" placeholder="Enter a color name"
                [ngClass]="{'is-invalid': submitted && c.controls.colour.errors}" formControlName="colour" 
                autocomplete="off" />
              <div class="invalid-feedback" *ngIf="submitted && c.controls.colour.errors">
                <span *ngIf="c.controls.colour.errors.required">Please provide a valid colour.</span>
                <span *ngIf="c.controls.colour.errors.pattern">Please provide a valid colour.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label for="icon" class="form-label">Icon</label>
            <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-palette"></i></span>
              <input type="text" class="form-control ps-1" id="icon" placeholder="Enter a icon name"
                [ngClass]="{'is-invalid': submitted && c.controls.icon.errors}" formControlName="icon" 
                autocomplete="off" />
              <div class="invalid-feedback" *ngIf="submitted && c.controls.icon.errors">
                <span *ngIf="c.controls.icon.errors.required">Please provide a valid icon.</span>
                <span *ngIf="c.controls.icon.errors.pattern">The icon must match the required format (eg:'bx bxl-whatsapp').</span>
              </div>
            </div>
          </div>
        <div class="col-md-auto">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
            <label class="form-check-label" for="disabled">Disabled</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
          class="bx bx-x"></i>Close</button>
      <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
        <ng-container *ngIf="inProgress?.value=='true'">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{socialMediaForm.value.id?'Updating...':'Saving...'}}
        </ng-container>
        <ng-container *ngIf="inProgress?.value!='true'">
          <i class="bx bx-save"></i>{{socialMediaForm.value.id?'Save Changes':'Save'}}
        </ng-container>
      </button>
    </div>
  </form>
  